import { render, staticRenderFns } from "./TgPrivilegeChangeDialog.vue?vue&type=template&id=77b586d9"
import script from "./TgPrivilegeChangeDialog.vue?vue&type=script&lang=js"
export * from "./TgPrivilegeChangeDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports